import MultiToggle from "PFComponents/multi_toggle/multi_toggle";
import React, { Dispatch, SetStateAction, useRef } from "react";

export enum DateGranularity {
  daily = "daily",
  weekly = "weekly",
  monthly = "monthly"
}

type Props = {
  selectedDate: string;
  setDateGranularity: Dispatch<SetStateAction<string>>;
};

const DateGranularitySelector = ({ selectedDate, setDateGranularity }: Props) => {
  const options = useRef([
    { id: DateGranularity.daily, value: DateGranularity.daily },
    { id: DateGranularity.weekly, value: DateGranularity.weekly },
    { id: DateGranularity.monthly, value: DateGranularity.monthly }
  ]);

  return (
    <MultiToggle options={options.current} defaultSelected={selectedDate} onChange={setDateGranularity} />
  );
};

export default DateGranularitySelector;
